import {
  useArchiveYearsFromContext,
  useCurrentOrganizationFromContext,
} from "app/core/providers/UserInfoProvider"

export const useHasArchiveYears = () => {
  const organization = useCurrentOrganizationFromContext()

  if (!organization?.archiveYears) {
    return false
  }

  return organization.archiveYears.length > 0
}
